import { observer } from 'mobx-react'

import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import ExportEmployeeSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportEmployeeSelector'
import ExportLeaveSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportLeaveSelector'
import ExportMonthSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportMonthSelector'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
  onEmployeeSelectionChange: (selector: EmployeeSelectorV2MultiSelectState) => void
}

const ScheduleTimeoffFields = ({ form, onEmployeeSelectionChange }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      <ExportLeaveSelector form={form} />
      <ExportMonthSelector form={form} />
    </>
  )
}

export default observer(ScheduleTimeoffFields)
